export const environment = {
  production: false,
  name: 'staging',
  authEnabled: true,
  // agw-tracer-v2 on staging. The v1 tracer is tracer-api.airgateway.work; the
  // Netlify CSP only allows the v2 hosts.
  tracerUrl: 'https://tracer-api-v2.airgateway.work',
  // NDC API + BookingPad, used only for the 'relaunch' deep link.
  apiUrl: 'https://api.airgateway.work',
  bpBackendUrl: 'https://backend.bookingpad.work',
  bpUrl: 'https://web.v2.bookingpad.work/',
  keycloakUrl: 'https://auth.airgateway.work',
  // Realm pre-selected on the login screen; the Admin tab switches to admins.
  keycloakRealm: 'agents',
  keycloakClientId: 'tracer',
};
